<!-- 监管类别名称 -->
<template> 
    <div>
        <el-dialog title="监管类别名称列表" :visible.sync="regulatoryShow" width="60%" :before-close="handleClose" :close-on-click-modal="false">
            <el-table ref="regulatoryList" :data="codeList" highlight-current-row @current-change="handleCurrentChange" 
            style="width: 100%" height="400px">
                <el-table-column type="index" width="50"> </el-table-column>
                <el-table-column property="name" label="监管类别名称" width=""> </el-table-column>
                <el-table-column property="" label="类型" width=""> </el-table-column>
                <el-table-column property="hsCode" label="HS代码" width=""> </el-table-column>
                <el-table-column property="hsName" label="HS名称" width=""> </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="handleClose">关 闭</el-button>
                <el-button type="primary" @click="sureRegulatory">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>

export default {
    props: {
    },
    data() {
        return {
            selectedTable:[], // 表格选中数据
            regulatoryShow:false,
            codeList:[], // 监管列表
        }
    },
    watch: {
    },
    mounted() { 

    },
    methods: { 
        // 查询监管列表
        getList(codeTs,ciqCode){
            this.$api.getHsCiqByHsCode(  codeTs  ).then(res =>{
                this.regulatoryShow = true
                this.codeList = res.ciqs.map(item => {
                    return { ...item ,hsCode:res.hsCode,hsName:res.hsName}
                })
                this.$nextTick(() => {
                    // 如果有ciqCode则显示已选中的那条
                    if(ciqCode !== ''){
                        const ciqList = this.codeList.filter(item =>
                            item.id.toLowerCase().includes(ciqCode.toLowerCase())
                        );
                        this.$refs.regulatoryList.setCurrentRow(ciqList[0])
                    }else{
                        this.$refs.regulatoryList.setCurrentRow(this.codeList[0])
                    }
                });
            })
        },
        // 选中表格数据
        handleCurrentChange(val){
            this.selectedTable = val
        },
        // 关闭不返值
        handleClose() {
            this.regulatoryShow = false
            this.$emit('regulatoryClose','');
        },
        // 返值
        sureRegulatory(){
            this.regulatoryShow = false
            // 返回选中值
            this.$emit('regulatoryClose', this.selectedTable);
        }
    }
}
</script>
<style lang="css" scoped>

</style>